/**
 * 默认校验规则表 —— 按字段名组织的额外校验规则
 *
 * ═══════════════════════════════════════════════════════════
 * 命名规则：moduleFieldName（小驼峰，无连字符）
 * ═══════════════════════════════════════════════════════════
 *
 *  部分              含义                       示例
 * ─────────────────────────────────────────────────────────
 *  moduleFieldName   模块+字段名拼接             addressDetailAddr / orderPhone / commonPhone
 *
 * 多模块共用的校验规则，使用 "common" 前缀：
 *   例：commonPhone（地址/订单等都可能校验手机号）
 *
 * 国家层可追加同名字段的规则（数组 concat 合并，不替换）
 */
export const FIELD_RULES: Record<string, any[]> = {
  /** 地址 - 详细地址字段的额外校验 */
  addressDetailAddr: [],

  /** 通用 - 手机号字段的额外校验 */
  commonPhone: []
}
